import { User, UserCredentials } from "./authTypes";
import {
  hasACKPermission,
  hasConfigPermission,
  hasControlPanelEditPermission,
  hasControlPanelPermission,
  hasLastBatchPermission,
  hasRemoteDesktopPermission,
  hasSwitchPermission,
} from "./permissionConfig";
import { setUserConfig } from "./userModel";

const CURRENT_USER = setUserConfig();
export const setUser = (user: User) => CURRENT_USER.setUser(user);
export const getCurrentUser = () => CURRENT_USER.getUserData();
export const getAsyncCurrentUser = () => CURRENT_USER.getAsyncUserData();
export const getObservableCurrentUser = () =>
  CURRENT_USER.getObservableUserData();
export const changeCurrentFactory = (factory: string) =>
  CURRENT_USER.changeFactory(factory);
export const getFactoryChangeObservable = () =>
  CURRENT_USER.getFactoryChangeObservable();
export const setUserCredentials = (credentials: UserCredentials) =>
  CURRENT_USER.setUserCredentials(credentials);
export const getUserCredentials = () => CURRENT_USER.getUserCredentials();
export const getUserIsActiveInterval = () =>
  CURRENT_USER.getUserIsActiveInterval();

export const checkACKPermission = hasACKPermission;
export const checkSwitchPermission = hasSwitchPermission;
export const checkConfigPermission = hasConfigPermission;
export const checkRemoteDesktopPermission = hasRemoteDesktopPermission;
export const checkLastBatchPermission = hasLastBatchPermission;
export const checkControlPanelPermission = hasControlPanelPermission;
export const checkControlPanelEditPermission = hasControlPanelEditPermission;
